module.exports = __webpack_public_path__ + "img/blue_166.88281429.png";